import React, { Fragment, useEffect, useState } from 'react';
import { Button, Card, CardBody, Col, Row, Label, Input, FormGroup, FormFeedback } from 'reactstrap';
import moment from 'moment';
import DataReactTableBillfold from './DataReactTableBillfold';
import { formatNumber } from '../../Utils/Money';
import Spinner from 'react-bootstrap/Spinner';
import { InvoiceUtils } from '../../Billing/InvoiceCustomers/SearchInvoiceCostumers/components/InvoiceUtils';
import InvoiceDisplay from './InvoiceDisplay/InvoiceDisplay';
import history from '../../../history';


const BillfoldInvoiceList = () => {
    const [invoices, setInvoices] = useState(null);
    const [dates, setDates] = useState({ start: new Date(), end: new Date() });
    const [load, setLoad] = useState(false);
    const [dataInvoice, setDataInvoice] = useState(null);
    const [showInvoiceDetails, setShowInvoiceDetails] = useState(false);
    const [selectedInvoice, setSelectedInvoice] = useState(null);

    useEffect(() => {
        listInvoice();
    }, [])


    const listInvoice = async () => {
        setLoad(true);
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'facturas/listar', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
        })
            .then(response => {
                return response.json();
            })
            .then(data => {
                if (data.length > 0) {
                    console.log("FACTURAS", data);
                    setInvoices(data);
                }
                else {
                    setInvoices([]);
                }
                setLoad(false);
            })
            .catch((error) => {
                setLoad(false);
                console.error('Error:', error);
            });

    }

    const loadIdentity = (num_documento) => {
        return new Promise((resolve, reject) => {
            var data = { num_documento: num_documento };
            fetch(process.env.REACT_APP_PUBLIC_URL + 'paciente/consultar', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: JSON.stringify(data)
            })
                .then(response => {
                    return response.json();
                })
                .then(data => {
                    console.log('response', data)
                    if (data.existe) {
                        resolve(data);
                    } else {
                        resolve({ existe: false });
                    }
                })
                .catch((error) => {
                    console.error('Error:', error);
                });
        })
    }

    const goToAccountStatus = (dataInvoice) => {
        console.log("INFO", dataInvoice)
        if(dataInvoice?.tipo !== null){
            if(dataInvoice?.tipo == 1){ //Cuando el paciente es particular busca el estado de cuenta del paciente
                loadIdentity(dataInvoice?.documento_paciente_facturado).then((data)=>{
                    if (data.existe == true) {
                        history.push({
                            pathname: process.env.PUBLIC_URL + '/management/financial-status-account',
                            state: { 
                                client: data.contenido[0],
                                id_third: null
                             }
                        });
                    }
        
                })
            }else{
                loadIdentity(dataInvoice?.documento_paciente_facturado).then((data)=>{ //Cuando el regimen es diferente a Particular busca el estado de cuenta del tercero
                    if (data.existe == true) {
                        history.push({
                            pathname: process.env.PUBLIC_URL + '/management/financial-status-account',
                            state: { 
                                client: data.contenido[0],
                                id_third: dataInvoice?.id_tercero
                             }
                        });
                    }
        
                })
            }
        }else{
            alert('No hay información que mostrar')
        }
    }


    const reactTableData = {
        tableHeaderData: [{
            Header: 'DOCS N°',
            accessor: 'num_fac_ter',
            Cell: row => (
                <label>
                    {(row.value)}
                </label>
            )
        },
        {
            Header: 'FECHA EMISION',
            accessor: 'fecha_emision',
            Cell: row => (
                <label>
                    {moment(row.value).format('DD-MM-YYYY')}
                </label>
            )
        },
        {
            Header: 'FECHA VENCIMIENTO',
            accessor: 'vencimiento',
            Cell: row => (
                <label>
                    {moment(row.value).format('DD-MM-YYYY')}
                </label>
            )
        },
        {
            Header: 'TIPO DE FACTURA',
            accessor: 'factura_tipo_fe',
            Cell: row => (
                <label>
                    {row.value}
                </label>
            )
        },
        {
            Header: 'NOTA CRÉDITO',
            accessor: 'folio_nota_credito',
            Cell: row => (
                <label>
                    {row.value != null ? row.value : "No Aplica"}
                </label>
            )
        },
        {
            Header: 'CLIENTE',
            accessor: 'nombre_facturado',
            Cell: row => (
                <label>
                    <a href='#' onClick={() => goToAccountStatus(row.row.original)}>{row.value}</a>
                </label>
            )
        },
        {
            Header: 'DOCUMENTO',
            accessor: 'num_documento',
            Cell: row => (
                <label>
                    {row.value}
                </label>
            )
        },
        {
            Header: 'DOCUMENTO DEL PACIENTE',
            accessor: 'documento_paciente_facturado',
            Cell: row => (
                <label>
                    {row.value}
                </label>
            )
        },
        {
            Header: 'NOMBRE DEL PACIENTE',
            accessor: 'nombre_paciente_facturado',
            Cell: row => (
                <label>
                    {row.value}
                </label>
            )
        },
        {
            Header: 'TOTAL',
            accessor: 'total',
            Cell: row => (
                <label>
                    ${formatNumber(row.value)}
                </label>
            )
        }
        ],
        tableRowsData: invoices
    };

    const RenderTableInvoices = () => {
        let fechaInicial = moment(dates.start).format('YYYY/MM/DD');
        let fechaFinal = moment(dates.end).format('YYYY/MM/DD');
        return (<DataReactTableBillfold
            reactTableData={reactTableData}
            fechaInicial={fechaInicial}
            fechaFinal={fechaFinal}
            showDetailsInvoice={showDetailsInvoice}
        />);
    }

    const showDetailsInvoice = async (invoice) => {
        setSelectedInvoice(invoice);
        let invoiceUtils = new InvoiceUtils();
        let idsReceipts = invoiceUtils.extractIdForReceipts(invoice);
        await invoiceUtils.getReceiptsById(idsReceipts, invoice.id_tercero, invoice.num_fac_ter, invoice.folio_nota_credito).then((res) => {
            console.log("RESULT", res)
            if (res != null) {
                /* if (res.factura.recibosCaja.length > 1) {
                  //InvoiceUt.generatePDFPrevisualizationInvoices(res.factura, data.data.original.es_factura);
                } else {
                  //InvoiceUt.generatePDFPrevisualization(res.factura, data.data.original.es_factura);
                } */
                setDataInvoice(res?.factura)
            } else {
                console.log("Error consultando la Previsualizacion de la Factura");
            }

        }).catch((error) => {
            console.log("Error", error);
            alert("No se pudo consultar información de la Factura ")
        })
        setShowInvoiceDetails(true);
    }

    return (
        <Fragment>
            <Card>
                <CardBody style={{ height: '100%' }}>
                    {showInvoiceDetails ?
                        dataInvoice &&
                        <Fragment>
                            <Row>
                                <InvoiceDisplay dataInvoice={dataInvoice} selectedInvoice={selectedInvoice} />
                            </Row>
                        </Fragment>
                        : null}
                    <Row>
                        <Col>
                            <h5><b>Lista de Facturas</b></h5>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            {!load && invoices ? <RenderTableInvoices /> : <div className="text-center">
                                <Spinner style={{ width: '35px', height: '35px', color: '#4ce1b6' }} animation="border" /></div>}
                        </Col>
                    </Row>
                </CardBody>
            </Card>
        </Fragment>
    )
}

export default BillfoldInvoiceList